import HtmlUtil from '../utilities/html-util'

export default {
  methods: {
    handleScrollNav({id}) {
      const el = document.getElementById(id);
      this.scrollTo(el);
    },
    scrollTo(el, duration, options) {
      HtmlUtil.scrollTo(el, duration, options);
    }
  }
}